import createLogger from '@kcuf/sls-logger-web';
import getEnv from '@lcai/console-env';
import { getDefaultParams } from './util';
export var SLS_OPTIONS = {
  project: 'lcai-console',
  endpoint: 'cn-wulanchabu.log.aliyuncs.com',
  logstore: getEnv(),
  defaultParams: getDefaultParams
};
export default createLogger(SLS_OPTIONS);
//# sourceMappingURL=index.js.map